module.exports = __webpack_public_path__ + "img/camera.7df9fbc9.png";